import { getConsent, useConsent } from './consent'

/**
 * Conversion events.
 *
 * Vercel Web Analytics is loaded from public/index.html (the script-tag
 * install, no npm package) and exposes `window.va`. Until Analytics is
 * enabled for the project in the Vercel dashboard the calls are harmless
 * no-ops, so every page and form can report events from day one.
 *
 * Keep names stable: they become the funnel in the dashboard.
 *   quote_submitted      homepage / contact form sent
 *   readiness_submitted  readiness check lead sent
 *   estimate_completed   estimator reached the result screen
 *   estimate_sent        estimator breakdown emailed
 *   call_click           any "book a call" button
 *   estimator_click      any "estimate my project" button (with `from`)
 */
let loaded = false

// Loads the Vercel script once the "analytics" category is on. Cookieless,
// but a visitor who opted out of being counted is not counted.
export const loadAnalyticsIfAllowed = () => {
  if (loaded || typeof document === 'undefined') return
  if (process.env.NODE_ENV !== 'production') return
  const consent = getConsent()
  if (!consent || !consent.analytics) return
  loaded = true
  const script = document.createElement('script')
  script.defer = true
  script.src = '/_vercel/insights/script.js'
  document.head.appendChild(script)
}

// Mount once (Layout does) so a choice made on any page loads the script.
export const useAnalyticsLoader = () => {
  const consent = useConsent()
  if (consent && consent.analytics) loadAnalyticsIfAllowed()
}

export const track = (name, data) => {
  try {
    const consent = getConsent()
    if (!consent || !consent.analytics) return
    if (typeof window !== 'undefined' && typeof window.va === 'function') {
      window.va('event', { name, data })
    }
  } catch (e) {
    // analytics must never break the page
  }
}

export default track
